import { useRef } from 'react';
import { useTranslation } from 'next-i18next';

import IconWrapper from '@components/ui/Icons';
import { usePdp } from '@context/PdpContext';

import useObjectVisibility from '@hooks/useObjectVisibility';
import usePrefersReducedMotion from '@hooks/usePrefersReducedMotion';

import styles from './ProductLowInventory.module.scss';

export const lowInventoryThreshold = (() => {
  const threshold = Number(process.env.NEXT_PUBLIC_LOW_INVENTORY_THRESHOLD);
  return isNaN(threshold) ? 5 : threshold;
})();

const ProductLowInventory = () => {
  const { selectedVariant } = usePdp();
  const { t } = useTranslation('pdp');
  const iconRef = useRef<HTMLDivElement | null>(null);

  const isVisible = useObjectVisibility(iconRef);
  const prefersReducedMotion = usePrefersReducedMotion();

  const availableToSell = selectedVariant?.inventoryAggregated?.availableToSell;
  const hasAdequateInventory =
    availableToSell === undefined || availableToSell > lowInventoryThreshold;

  if (hasAdequateInventory) {
    return <div ref={iconRef} style={{ display: 'none' }} />; // doing this rather than returning null to keep the ref
  }

  return (
    <div className={styles.container} ref={iconRef}>
      <IconWrapper
        icon={isVisible && !prefersReducedMotion ? 'fire-animate' : 'fire'}
        height={24}
        fill="var(--color-red)"
        classNames={styles.icon}
      />
      <span className={styles.text}>{t('product.quantity.low.cta')}</span>
    </div>
  );
};

export default ProductLowInventory;
